import type { ElementValue } from '@vedalib/editor/lib/elements'
import {
  TestAnswerFeedbackDisplayOption,
  TestAnswerFeedbackType,
} from '@vedalib/editor/lib/elements'

import ControlItem from 'components/Editor/cource/layout/controls/ControlItem'
import type { IMenuOption } from 'components/uiKit/Menu'
import type { ElementState } from 'services/Store/Project/types'
import { t } from 'services/Translation'

interface ITestElementChangeStateProps<T = ElementState> {
  value: ElementValue
  setState?: (value: T) => void
  state?: T
}
const CHANGE_STATE_ACTION: IMenuOption<'CHANGE_STATE'> = {
  icon: 'otherSwitch',
  label: t('elements.testAnswerFeedback.tooltip.switch.label'),
  value: 'CHANGE_STATE',
}

const TestElementChangeStateActions = <T extends { generalFbValid?: boolean }>({
  value,
  setState,
  state,
}: ITestElementChangeStateProps<T>) => {
  const generalFb =
    value.displayFeedback && value.displayOption !== TestAnswerFeedbackDisplayOption.perOption

  const change = () => setState?.({ ...state, generalFbValid: !state?.generalFbValid } as T)

  return (
    generalFb &&
    value.generalTypeFb === TestAnswerFeedbackType.validation && (
      <ControlItem handler={change} option={CHANGE_STATE_ACTION} />
    )
  )
}

export default TestElementChangeStateActions
